import React from 'react';

export const PedidoItemAction = props => (
  <li onClick={(e) => props.handlePermissionsMassive(e,props.pedidos) && props.action(props.actionParam)}>
    <a className='text-nowrap' data-permisos={props.permiso}>
      <i className={`${props.iconClass} mr-2 c-cyan`} />
      {props.name}
    </a>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/MenuItem.js